<p-dialog #mydiv header="{{dialogTitle}}" [(visible)]="displayDialog" [modal]="true"
    [style]="{width: '500px', height: '250px'}" [closable]="false" [resizable]="true" [draggable]="true"
    [dismissableMask]="true" [contentStyle]="{height: 'calc(100% - 50px)', overflow: 'auto'}">

    <div class="p-fluid" style="height: 80%;">
        <div class="p-d-flex p-jc-between p-ai-center p-mb-3 text-padding" style="height: 100%;">
            <p-dropdown #dropdown [options]="dialogList" [(ngModel)]="dialogSelect" filter="true"
                 [showClear]="true" 
                styleClass="custom-dropdown" [placeholder]="dialogPlaceholder" [appendTo]="'body'" style="width: 100%;">

                <ng-template let-item pTemplate="selectedItem">
                    <span style="vertical-align: middle; margin-left: .5em">{{item.label}}</span>
                </ng-template>
                <ng-template appendTo let-item pTemplate="item">
                    <div class="ui-helper-clearfix" style="position: relative; height: 25px;">
                        <div style="font-size: 14px; float: right; margin-top: 4px;">{{item.label}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>

    <div class="p-col-12 p-d-flex p-jc-end p-ai-center" style="margin-top: auto;">
        <button pButton type="button" label="Reset" icon="pi pi-times" class="p-button-secondary p-mr-2"
            (click)="resetFilter()"></button>
        &nbsp;&nbsp;
        <button pButton type="button" label="Apply" icon="pi pi-check" class="p-button-primary"
            (click)="applyFilter()"></button>
    </div>
</p-dialog>